<template>
    <div>
        <div :class="[device_type === 'ios' || device_type === 'android' ? 'mainwrap' : 'mainwrap_pc']" :style="{ maxWidth: location_pathname === '/view/admin/statis/map' ? 'unset' : null, display: is_should_hidden ? 'none' : null }">
            <keep-alive exclude="">
                <template v-if="is_app">
                    <!--<template v-if="$route.path.indexOf('/view/mercenary') > -1 || $route.path.indexOf('/view/home') > -1 || $route.path.indexOf('/now') > -1">-->
                    <template v-if="is_statubar_height_loaded && $GlobalStore.isLogin() && is_loaded">
                        <template v-if="$route.path === '/view/soccer_join' || $route.path === '/view/soccer_learn' || $route.path === '/view/mercenary' || $route.path === '/training_main'">
                            <router-view class="router_contents" :key="$route.fullPath" :style="{ paddingBottom: $GlobalStore.navigationBarHeight() + 'px' }"></router-view>
                        </template>
                        <template>
                            <router-view class="router_contents" :key="$route.fullPath" :style="{ paddingTop: $GlobalStore.statusBarHeight() + 'px', paddingBottom: $GlobalStore.navigationBarHeight() + 'px' }"></router-view>
                        </template>
                    </template>
                </template>
                <template v-else-if="is_statubar_height_loaded && is_loaded">
                    <router-view class="router_contents" :key="$route.fullPath" :style="{ paddingTop: $GlobalStore.statusBarHeight() + 'px', paddingBottom: $GlobalStore.navigationBarHeight() + 'px' }"></router-view>
                </template>
            </keep-alive>
        </div>
        <div class="modaldiv">
            <transition-group :name="$GlobalStore.modalTransitionName()">
                <div v-for="each, index in $store.state.modals" :class="[device_type === 'ios' || device_type === 'android' ? 'each_modal' : 'each_modal_pc']" :key="each.view + index" :ref="'modalRef' + index" :style="{
                    transition: each.isLeaving ? 'top .3s' : '',
                    bottom: '',
                    height: '',
                    backgroundColor: each.isModalBackTransparent ? 'transparent' : '',
                    top: each.isLeaving ? '100%' : ''
                }">
                    <!-- 채팅창 키보드 올라올때 ios 상단 흰색부분 막기 -->
                    <div v-if="each.view === 'JoinChat' || each.view === 'TrainingRequestDetail'" style="position:absolute; top:-500px; left:0px; width:100%; height:500px; background-color: white;"></div>
                    <div class="bounce_back_cover" :ref="'modalRefBack' + index" :style="{ backgroundColor: each.isModalBackTransparent ? 'transparent' : '' }"></div>
                    <!--<div class="modal">-->
                    <component class="modal" :style="{
                        position: each.view === 'FindPositionProResult' ? '' : 'relative',
                        paddingTop: each.view === 'LoginIntro' || each.view === 'ImageViewer' || each.is_modal_full_screen ? null : $GlobalStore.statusBarHeight() + 'px',
                        paddingBottom: each.view === 'LoginIntro' || each.view === 'ImageViewer' || each.is_modal_full_screen ? null : $GlobalStore.navigationBarHeight() + 'px'
                    }" :is="each.view" v-bind="each"></component>
                    <!--</div>-->

                </div>
            </transition-group>
        </div>
        <transition name="fade_toast">
            <AppLinkToast v-show="$GlobalStore.isShowAppLinkToast()"></AppLinkToast>
        </transition>
        <customprogress v-if="$GlobalStore.isShowProgress()"></customprogress>

        <transition name="fade2">
            <propose-scout-animation v-if="$GlobalStore.isShowPayAnimation()"></propose-scout-animation>
        </transition>
        <transition name="fade">
            <showpromodal v-if="$GlobalStore.isShowProModal()"></showpromodal>
        </transition>
        <transition name="fadeTop2">
            <CompleteProCondition v-if="$GlobalStore.isShowCompleteProCondition()"></CompleteProCondition>
        </transition>
        <systempatch v-if="!$GlobalStore.isShowUpdatePopup()"></systempatch>
        <transition name="fadeTop">
            <updatepopup v-if="$GlobalStore.isShowUpdatePopup()"></updatepopup>
        </transition>
        <toastVer2></toastVer2>
        <toast></toast>
        <Confirm v-if="$GlobalStore.isShowConfirm()"></Confirm>
        <div v-if="is_test_server" style="position:fixed; left:5px; top:5px; color:red; font-size:16px;">[TEST]</div>
        <NotExpert :isOpen="$GlobalStore.isShowBookmarkPopupNotExpert()" :closeModal="$GlobalStore.closeIsShowBookmarkPopupNotExpert"></NotExpert>
        <BookmarkPopup :isShowBookmarkPopup="isShowBookmarkPopupConfirmed" :closeBookmarkPopup="() => { isShowBookmarkPopupConfirmed = false }">
            <div>
                <div @click="confirmCoach" style="font-weight: 700;">닫기</div>
                <div style="text-align: center;">
                    <img style="width: 195px;" :src="require('@/assets/img/confirmed_coach.png')" alt="">
                </div>
                <div style="margin-top: 20px; font-size: 20px; line-height: 24px; font-weight: 700; text-align: center;">전문가 인증이 완료되어<br>모든 요청들을 확인할 수 있습니다!</div>
                <div @click="confirmCoach" style="width: 186px; margin: 0 auto; height: 56px; display: flex; justify-content: center; align-items: center; border-radius: 40px; background-color: #210f03; color: var(--color-main); font-size: 14px; font-weight: 700; margin-top: 40px;">확인</div>
            </div>
        </BookmarkPopup>
        <CommonBookMarkPopup :height="473" :isShowBookmarkPopup="$GlobalStore.isShowDirectRequestPopup()" :closeBookmarkPopup="closeDirectRequestPopup">
            <div @click="closeDirectRequestPopup" style="font-weight: 700;">닫기</div>
            <div>
                <div style="margin-top: 40px; text-align: center;">
                    <img style="width: 250px" :src="require('@/assets/img/bookmark_logo2.png')" alt="">
                </div>
                <div style="margin-top: 24px; text-align: center; white-space: nowrap; font-weight: 700; font-size: 20px; line-height: 32px;">감독님들은 회원님의 요청을 기다리고있어요!<br>다이렉트 요청서를 보내보는 건 어떨까요?</div>
                <div style="display: flex; gap: 12px; margin-top: 60px;">
                    <div @click="closeDirectRequestPopupOneDay" style="flex: 1; font-weight: 700; font-size: 14px; line-height: 56px; text-align: center; height: 56px; border-radius: 50px; background-color: #fff;">괜찮아요</div>
                    <div @click="sendRequestPost" style="flex: 1; font-weight: 700; font-size: 14px; line-height: 56px; color: var(--color-main); text-align: center; height: 56px; border-radius: 50px; background-color: #210f03;">네, 직접 보낼게요</div>
                </div>
            </div>
        </CommonBookMarkPopup>
        <Transition name="fade2">
            <MemberInfoPopup v-if="$GlobalStore.isShowMemberInfoPopup()"></MemberInfoPopup>
        </Transition>
        <TempCoachAgreement :is-open="isShowCoachAgreement" :close-action="() => { isShowCoachAgreement = false }" />
        <PrivacyPolicy :isShowPrivacyPolicy="$GlobalStore.isShowPrivacyPolicy()" :closePrivacyPolicy="$GlobalStore.closePrivacyPolicy"></PrivacyPolicy>
        <Transition name="fade">
            <div v-if="$GlobalStore.isShowRequestPopupForce()" style="position: fixed; z-index: 10; background: #210F0380; width: 100%; height: 100%; left: 0; top: 0; backdrop-filter: blur(10px);">
                <div style="width: 350px; padding-bottom: 24px; text-align: center; border-radius: 24px; background-color: #fff; position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%);">
                    <!-- <div @click="$GlobalStore.setIsShowRequestPopupForce(false)" style="font-weight: 700; line-height: 24px; padding-top: 16px; color: #808080; text-align: left; padding-left: 20px; margin-bottom: 20px;">닫기</div> -->
                    <div style="margin-top: 24px;">
                        <img style="width: 314px;" :src="require('@/assets/img/deok_bae_say.png')" alt="">
                    </div>
                    <div style="font-weight: 700; font-size: 20px; line-height: 32px; margin-top: 12px;">감독님들에게 보여 드릴<br><span style="color: var(--color-main);">입단 요청서</span>를 작성해 주세요</div>
                    <div style="margin-top: 5px; font-weight: 500; font-size: 12px; line-height: 20px; color: #606060;">요청서를 작성해두면 감독님들로부터 스카우트가 오거나,<br>내가 원하는 팀에 직접 테스트 요청을 할 수 있어요</div>
                    <div @click="setMakeRequestJoinForm(false); $Util.sendEventClick('선수희망_입단신청서_이동', true)" style="width: 263px; height: 48px; line-height: 48px; text-align: center; font-weight: 700; font-size: 12px; color: var(--color-main); margin: 0 auto; background-color: #210f03; border-radius: 50px; margin-top: 10px;">지금 입단서 작성하기</div>
                    <div @click="$GlobalStore.setIsShowRequestPopupForce(false)" style="margin-top: 10px; font-size: 12px; font-weight: 500; color: #606060; line-height: 20px; text-align: center;">다음에 작성하기</div> 
                </div>
            </div>
        </Transition>
        <div style="position: relative; z-index: 300;">
            <MakeRequestJoinForm :isPageFrame="true" :isForce="isForce" :isShowMakeRequestJoinForm="isShowMakeRequestJoinForm" :closeRequestJoinForm="closeRequestJoinForm"></MakeRequestJoinForm>
        </div>
        <BookmarkPopup :height="417" :isShowBookmarkPopup="$GlobalStore.isShowTransCoachPopup()" :closeBookmarkPopup="() => { $GlobalStore.setTransCoachPopup(false) }">
            <div>
                <div @click="$GlobalStore.setTransCoachPopup(false)" style="font-weight: 700;">닫기</div>
                <div style="text-align: center; margin-top: 17px;">
                    <img style="width: 150px;" :src="require('@/assets/img/not_expert.png')" alt="">
                </div>
                <div style="margin-top: 31px; font-size: 20px; font-weight: 700; line-height: 24px; text-align: center;">회원 가입 후 전문가 등록을 진행하지 않으면,<br>자동으로 일반 회원으로 전환됩니다.</div>
                <div style="display: flex; margin-top: 34px; gap: 12px;">
                    <div @click="$GlobalStore.setTransCoachPopup(false); $Util.sendEventClick('전문가인증_나중에하기', true)" style="height: 56px; flex: 1; line-height: 56px; text-align: center; border-radius: 40px; background-color: #fff; font-weight: 700; font-size: 14px;">나중에 하기</div>
                    <div @click="showInquiryPopup" style="height: 56px; flex: 1; line-height: 56px; text-align: center; border-radius: 40px; background-color: #210f03; font-weight: 700; font-size: 14px; color: var(--color-main);">지금 인증받기</div>
                </div>
            </div>
        </BookmarkPopup>
        <ModifyPopup v-if="$GlobalStore.isShowModifyPopup()"></ModifyPopup>
    </div>
</template>

<script>
import MemberInfoPopup from '@/components/common/MemberInfoPopup';
import ModifyPopup from '@/components/common/ModifyPopup';
import moment from 'moment'
import NotExpert from '@/components/common/NotExpert'
import KaKaoLogin from '@/components/modal/KaKaoLogin';
import KaKaoRegist from '@/components/modal/KaKaoRegist';
import JoinChat from '@/components/modal/JoinChat';
import ImageViewer from '@/components/modal/ImageViewer';
import Reservation from '@/components/modal/mylocation/Reservation';
import MyPosition from '@/components/page/MyPosition';
import Login from '@/components/modal/Login';
import MemberRegist from '@/components/modal/MemberRegist';
import axios from 'axios';
import Confirm from "./common/Confirm";
import CompleteProCondition from "@/components/common/CompleteProCondition"
import AppLinkToast from "@/components/common/AppLinkToast"
import PushManager from '@/modules/PushManager'
import LandingPage from '@/components/modal/LandingPage';
import FindAccount from '@/components/modal/FindAccount';
import MyMemberships from '@/components/modal/my/MyMemberships';
import LessonSchedules from '@/components/modal/my/LessonSchedules';
import {
    ASK_URL, SOCCER_HOW_TYPE, PUSH_ACTION, SOCCER_JOIN_SCHEDULE, TEST_SERVER_HOST_NAME, CLASS_TYPE, MAIN_TYPE, MEMBER_TYPE, JOIN_CHAT_TYPE, PARENT_PAY_TYPE
} from "../Constants";
import NoticeAll from '@/components/modal/my/NoticeAll';
import BankAccountForm from '@/components/modal/bankaccount/BankAccountForm';
import RefundComplete from '@/components/modal/my/RefundComplete';
import DaumAddress from '@/components/modal/DaumAddress';
import MyMembershipsWithProgressing from '@/components/modal/my/MyMembershipsWithProgressing';

import PrivacyInfo from './modal/my/PrivacyInfo';
import LoginSecurity from './modal/my/LoginSecurity';
import PaymentRegist from './modal/my/PaymentRegist';
import ShowEvent from './modal/my/ShowEvent';
import Notification from './modal/my/Notification';
import ReportHistory from './modal/my/ReportHistory';
import PhoneEdit from './modal/my/PhoneEdit';
import AccountDisabled from './modal/my/AccountDisabled';
import CardAdd from './modal/my/CardAdd';
import NotificationDetail from './modal/my/NotificationDetail';
import Util from "../modules/util";
import FindPositionStart from './modal/my/FindPositionStart';
import Payment from './page/Payment';
import AccountRegist from './modal/my/AccountRegist';
import FindPositionProStart from './page/FindPositionProStart';
import MyPositionPro from './page/MyPositionPro';
import MyPositionProMain from './page/MyPositionProMain';
import FindPositionProResult from './page/FindPositionProResult';
import MyPositionResult from './common/MyPositionResult';
import TempLessonList from './modal/lesson/TempLessonList';
import SelectFindPosition from './modal/my/SelectFindPosition';
import NewMakeMercenarySchedule from './mercenary/NewMakeMercenarySchedule';
import MakeMemberTalk from './modal/soccerjoin/MakeMemberTalk';
import PrivateMemberTalk from './modal/soccerjoin/PrivateMemberTalk';
import MemberTalkDetailSetting from './modal/soccerjoin/MemberTalkDetailSetting';
import MemberTalkSetting from './modal/soccerjoin/MemberTalkSetting';
import MemberTalkScheduleDetailModalWrap from './modal/soccerjoin/MemberTalkScheduleDetailModalWrap';
import FindAccount2 from '@/components/modal/FindAccount2'
import MemberRegistStepTwo from './modal/MemberRegistStepTwo.vue';
import WelcomeBack from './modal/WelcomeBack';
import CompletePay from './page/CompletePay';
import TestModal from './modal/TestModal';
import ProfileMain from './page/ProfileMain.vue';
import AlarmManage from './modal/my/AlarmManage';
import ActivityAndSettings from './modal/my/ActivityAndSettings';
import CoachRegister from './modal/coach/CoachRegister';
import MyProfileEdit from './modal/my/MyProfileEdit.vue';
import CoachDocComplete from './modal/coach/CoachDocComplete';
import CoachDocRegister from './modal/coach/CoachDocRegister';
import CoachRegisterExplanation from './modal/coach/CoachRegisterExplanation';
import CoachCareerRegister from './modal/coach/CoachCareerRegister';
import CoachCertRegister from './modal/coach/CoachCertRegister';
import SupportActivity from './modal/my/SupportActivity';
import CoachIntroduceManage from './modal/coach/CoachIntroduceManage';
import MemberTalkImageViewer from './modal/soccerjoin/MemberTalkImageViewer.vue';
import MemberTypeSelect from './modal/MemberTypeSelect';
import MakeClassScheduleFeedPopup from './modal/lesson/MakeClassScheduleFeedPopup';
import ClassScheduleDetail from './modal/lesson/ClassScheduleDetail';
import MakeClassScheduleFeed from './modal/lesson/MakeClassScheduleFeed';
import ModalFindMercenaryPopup from './common/ModalFindMercenaryPopup';
import PaymentDetailList from './modal/my/PaymentDetailList'
import PaymentDetail from './modal/my/PaymentDetail'
import MercenaryScheduleDetailPopup from './common/MercenaryScheduleDetailPopup'
import TempCoachAgreement from "./common/TempCoachAgreement";
import ReportPopup from './modal/ReportPopup.vue';
import ReportHistoryNew from './modal/my/ReportHistoryNew'
import ReportHistoryDetail from './modal/my/ReportHistoryDetail'
import PersonalChatSetting from './modal/chatting/PersonalChatSetting'
import PositionResultDelay from './page/PositionResultDelay.vue'
import SettingPlacePopup from './modal/SettingPlacePoup'
import PositionProFreePopup from './page/PositionProFreePopup'
import InviteMemberPopup from './page/InviteMemberPopup'
import CompleteWithdrawal from './modal/my/CompleteWithdrawal'
import SchemeManager from "../modules/SchemeManager";
import RegistTypeSelect from './modal/RegistTypeSelect';
import TeamTrainingDetail from './mercenary/TeamTrainingDetail'
import MyClassReservation from './modal/lesson/MyClassReservation'
import TeamTrainingWriteForm from './mercenary/TeamTrainingWriteForm';
import TodayActivity from './modal/my/TodayActivity.vue';
import SignupCommonFrame from './common/SignupCommonFrame';
import LoginIntro from './common/LoginIntro.vue';
import SoccerhowCustomerSupport from './mercenary/SoccerhowCustomerSupport'
import SpotLightList from './soccerhowmain/SpotLightList';
import InterviewDetail from './soccerhowmain/InterviewDetail';
import SoccerhowRealTimeNews from './soccerhowmain/SoccerhowRealTimeNews';
import RequestReportDetail from './soccerhowmain/RequestReportDetail';
import DirectMessageList from './common/DirectMessageList.vue';
import SendIndividualMessage from './soccerhowmain/SendIndividualMessage';
import TrainingRequestDetail from '@/components/soccerhowmain/TrainingRequestDetail';
import SoccerTeamDetail from './soccerhowmain/SoccerTeamDetail';
import MakeMemberTalkNew from './soccerhowmain/MakeMemberTalkNew.vue';
import TestRequestPay from './modal/tests/TestRequestPay.vue';
import TestParentPay from './modal/tests/TestParentPay.vue';
import FriendsList from './soccerhowmain/FriendsList.vue';
import ExpertInformation from './soccerhowmain/ExpertInformation.vue';
import MemberTalkMemberList from './modal/soccerjoin/MemberTalkMemberList.vue';
import RequestPayForm from './soccerhowmain/RequestPayForm.vue';
import YouthCertificationForm from './soccerhowmain/YouthCertificationForm.vue';
import CompletePayNew from './page/CompletePayNew.vue';
import YouthPayRequestForm from './soccerhowmain/YouthPayRequestForm.vue';
import ActivityRanking from './page/ActivityRanking.vue';
import SignupExpertInfo from './common/SignupExpertInfo.vue';
import Pedometer from '@/modules/Pedometer'
import YouthFamilyAuth from './modal/my/YouthFamilyAuth'
import MyPostList from './soccerhowmain/MyPostList';
import PopupBeforePositionPro from './modal/popup/PopupBeforePositionPro.vue';
import BookmarkPopup from "./soccerhowmain/BookmarkPopup";
import ResponseCode from "../ResponseCode";
import FindPositionProMain from './modal/FindPositionProMain.vue';
import VideoViewer from './common/VideoViewer.vue';
import IntergrationSearch from './page/IntergrationSearch.vue';
import TeamTrainingMng from './modal/team_training_mng/TeamTrainingMng';
import TeamTrainingMngDetail from './modal/team_training_mng/TeamTrainingMngDetail';
import TeamTrainingNoticeForm from './modal/team_training_mng/TeamTrainingNoticeForm';
import TeamTrainingMngHistory from './modal/team_training_mng/TeamTrainingMngHistory';
import TeamTrainingMngMember from './modal/team_training_mng/TeamTrainingMngMember';
import PrivacyPolicy from './modal/PrivacyPolicy.vue';
import SplashPopup from './modal/popup/SplashPopup.vue';
import RequestReportList from './soccerhowmain/RequestReportList.vue';
import ChatOpenPopup from './modal/popup/ChatOpenPopup.vue';
import SendReview from './modal/lesson/SendReview'
import ReviewHistory from './modal/lesson/ReviewHistory'
import MakeMemberMngChat from './soccerhowmain/MakeMemberMngChat.vue';
import InviteMemberPage from './page/InviteMemberPage.vue';
import SignupPopupModal from './common/SignupPopupModal'
import NoticeDetail from './soccerhowmain/NoticeDetail'
import CommonBookMarkPopup from '@/components/soccerhowmain/CommonBookMarkPopup';
import SendOneRequestPost from './soccerhowmain/SendOneRequestPost.vue';
import FindPositionLite from './modal/FindPositionLite.vue';
import PollPostDetail from './soccerhowmain/PollPostDetail'
import LearnBannerDetail from './soccerhowmain/LearnBannerDetail.vue';
import MakeRequestJoinFormPopup from './soccerhowmain/MakeRequestJoinFormPopup.vue';
import MakeRequestJoinForm from '@/components/soccerhowmain/MakeRequestJoinForm'
import MenuService from '@/components/modal/MenuService'
import MakeFeed from '@/components/modal/MakeFeed'
import MyFriendsPopup from '@/components/modal/membertalk/MyFriendsPopup';
import AllMemberTalkPopup from '@/components/modal/membertalk/AllMemberTalkPopup';
import UploadGuidePopup from '@/components/modal/popup/UploadGuidePopup';
import SendTrainingVideoComplete from '@/components/page/SendTrainingVideoComplete';
import SendTrainingFeedback from '@/components/soccerhowmain/SendTrainingFeedback.vue';
import TrainingExplanation from '@/components/modal/TrainingExplanation';
import MembershipLevel from '@/components/modal/MembershipLevel';
import ScoutingReport from '@/components/modal/ScoutingReport'
import CoachingReport from '@/components/modal/CoachingReport'
import PersonalHistoryForm from '@/components/modal/PersonalHistoryForm.vue';
import ActivityHistory from '@/components/modal/ActivityHistory.vue';
import GrowthReport from '@/components/modal/GrowthReport.vue';
import EventPage from '@/components/modal/EventPage.vue';
import ScoutingReportDetail from '@/components/modal/ScoutingReportDetail.vue';
import SecretAgent from '@/components/modal/SecretAgent.vue';
import CompleteMissonPopup from '@/components/common/CompleteMissonPopup'
import NewTrainingVideoPopup from '@/components/common/NewTrainingVideoPopup'
import RequestReportDetailNew from './soccerhowmain/RequestReportDetailNew.vue'
import CurrentScout from './soccerhowmain/CurrentScout.vue'
import SelectPlayerType from './soccerhowmain/SelectPlayerType.vue'
import WriteDefaultInfoForm from './soccerhowmain/WriteDefaultInfoForm.vue'
import CurrentScoutUser from './soccerhowmain/CurrentScoutUser.vue'
import CurrentScoutUserSecret from './soccerhowmain/CurrentScoutUserSecret.vue'
import ExpertFeedbackModal from './modal/ExpertFeedbackModal.vue'
import DirectMessagePopupModal from './modal/DirectMessagePopupModal.vue'
import ModifyRequestList from './modal/ModifyRequestList.vue'
import SendRequestList from './modal/SendRequestList.vue'
import MakeFeedSoccerJoin from './modal/MakeFeedSoccerJoin.vue'
import SignupFindPosition from './modal/SignupFindPosition.vue'
import FindPositionHome from './modal/FindPositionHome.vue'
import ParentAuth from './modal/ParentAuth.vue'
import ModifyWriteDefaultInfoForm from './modal/ModifyWriteDefaultInfoForm.vue'
import LearnSoccerWriteFormModal from './modal/LearnSoccerWriteFormModal.vue'
import WriteGroundPost from './page/WriteGroundPost.vue'
import EventPopup from './common/EventPopup.vue'
import PaymentSecretRequestForm from './modal/PaymentSecretRequestForm.vue'
import TestSecretPay from './modal/tests/TestSecretPay'
import ParentPayWait from './modal/pay/ParentPayWait'
import SecretPayRequestform from './soccerhowmain/SecretPayRequestForm'
import WriteSecretDefaultInfoForm from './soccerhowmain/WriteSecretDefaultInfoForm.vue'
import RequestFormGuide from './soccerhowmain/RequestFormGuide.vue'
import UploadInstaImage from './soccerhowmain/UploadInstaImage.vue'
import MemberPopupList from './common/MemberPopupList.vue'
import MembershipGuide from './modal/MembershipGuide.vue'
import RatePlanModal from './common/RatePlanModal.vue'
import Loading from './page/Loading.vue'
import CommonAlertUi from '@/components/common/CommonAlertUi.vue'
import ElitePlayerAuthAlert from '@/components/common/ElitePlayerAuthAlert.vue'
import RequestReportDetailSecret from '@/components/soccerhowmain/RequestReportDetailSecret.vue'

export default {
    name: "PageFrame",
    // mixins : [commonmix],
    components: {
        MakeRequestJoinForm, ModifyPopup, EventPage, RequestReportDetailNew, SelectPlayerType, WriteDefaultInfoForm, CurrentScoutUser, CurrentScoutUserSecret,
        BookmarkPopup, AppLinkToast, SignupPopupModal, NoticeDetail, CommonBookMarkPopup, FindPositionLite, MakeFeed, SendTrainingVideoComplete,
        TempCoachAgreement, VideoViewer, IntergrationSearch, PrivacyPolicy, RequestReportList, SendReview, ReviewHistory, MakeMemberMngChat, InviteMemberPage,
        LoginIntro, SoccerhowCustomerSupport, ExpertInformation, SendIndividualMessage, TeamTrainingWriteForm,
        Confirm, SpotLightList, InterviewDetail, SoccerhowRealTimeNews, TrainingRequestDetail, MenuService, RequestReportDetailSecret,
        KaKaoLogin, KaKaoRegist, PrivacyInfo, LoginSecurity, ReportHistory, InviteMemberPopup, MembershipLevel,
        JoinChat, ImageViewer, Notification, PhoneEdit, CompleteWithdrawal, RequestPayForm, FindPositionProMain,
        PaymentRegist, ShowEvent, FindPositionStart, DirectMessageList, MakeMemberTalkNew, MyPostList, PollPostDetail,
        Reservation, RequestReportDetail, ActivityRanking, SendOneRequestPost, ScoutingReport, NewTrainingVideoPopup,
        AccountDisabled, FriendsList, MemberTalkMemberList, LearnBannerDetail, CompleteMissonPopup,
        MyPosition, Login, MemberRegist, PaymentDetail, CompletePayNew, SignupExpertInfo,
        LandingPage, FindAccount, MyMemberships, LessonSchedules, CardAdd, ScoutingReportDetail,
        NoticeAll, BankAccountForm, RefundComplete, DaumAddress, AccountRegist, SecretAgent,
        MyMembershipsWithProgressing, FindPositionProStart, GrowthReport, ActivityHistory,
        MemberTalkDetailSetting, YouthCertificationForm, PersonalHistoryForm,
        YouthPayRequestForm, MemberInfoPopup, CoachingReport,
        NotificationDetail, ClassScheduleDetail, CompleteProCondition,
        Payment, MemberTalkImageViewer, PositionResultDelay,
        MyPositionPro, MyPositionProMain, ReportHistoryDetail,
        FindPositionProResult, MyPositionResult, PrivateMemberTalk,
        TempLessonList, SelectFindPosition, SendTrainingFeedback,
        ProfileMain, MakeClassScheduleFeedPopup, ReportHistoryNew, PositionProFreePopup,
        MakeMemberTalk, MakeClassScheduleFeed, PaymentDetailList, ReportPopup, PersonalChatSetting,
        MemberTalkSetting, MemberTalkScheduleDetailModalWrap, FindAccount2, MemberRegistStepTwo, WelcomeBack, CompletePay,
        TestModal, NewMakeMercenarySchedule,
        AlarmManage, ActivityAndSettings, CoachRegister, MyProfileEdit,
        CoachRegisterExplanation, CoachDocRegister, CoachDocComplete, CoachCertRegister, CoachCareerRegister, SupportActivity,
        CoachIntroduceManage, MemberTypeSelect, ModalFindMercenaryPopup,
        MercenaryScheduleDetailPopup, SignupFindPosition,
        SettingPlacePopup, RegistTypeSelect, TeamTrainingDetail, MyClassReservation,
        TodayActivity, SignupCommonFrame, NotExpert, TestRequestPay, TestParentPay, YouthFamilyAuth, PopupBeforePositionPro,
        TeamTrainingMng, TeamTrainingMngDetail, TeamTrainingNoticeForm, TeamTrainingMngHistory, TeamTrainingMngMember, SplashPopup, ChatOpenPopup,
        MakeRequestJoinFormPopup, SoccerTeamDetail, MyFriendsPopup, AllMemberTalkPopup, UploadGuidePopup, TrainingExplanation, CurrentScout, ExpertFeedbackModal, DirectMessagePopupModal, ModifyRequestList, SendRequestList, MakeFeedSoccerJoin, FindPositionHome,
        ParentAuth, ModifyWriteDefaultInfoForm, LearnSoccerWriteFormModal, WriteGroundPost, EventPopup, PaymentSecretRequestForm, TestSecretPay, ParentPayWait, WriteSecretDefaultInfoForm, SecretPayRequestform, RequestFormGuide, UploadInstaImage, MemberPopupList, MembershipGuide, RatePlanModal, Loading, CommonAlertUi, ElitePlayerAuthAlert

    },
    computed: {
        is_should_hidden() {
            for (const each_modal of this.$store.state.modals) {
                if (['LoginIntro', 'MemberRegist', 'SignupCommonFrame'].indexOf(each_modal.view) > -1) {
                    return true;
                }
            }

            return false;
        },
        is_test_server() {
            if (location.hostname) {
                return window.location.hostname === TEST_SERVER_HOST_NAME;
            } else {
                return false;
            }
        },
        is_app() {
            const device = this.$cookies.get('device');
            return device === 'ios' || device === 'android';
        },
        location_pathname() {
            return location.pathname;
        }
    },
    data: function () {
        return {
            addPushDeviceCnt: 0,
            isShowCoachAgreement: false,
            is_loaded: false,
            device_type: null,
            isShowBookmarkPopupConfirmed: false,
            is_statubar_height_loaded: false,
            isShowMakeRequestJoinForm: false,
            isForce: false,
            test11: false
        }
    },
    methods: {
        showInquiryPopup() {
            this.$GlobalStore.setTransCoachPopup(false)
            this.$Util.sendEventClick('전문가인증_지금인증받기', true)
            this.openChatCoachAndAdmin()
        },
        async openChatCoachAndAdmin() {
            await this.$Axios.showPersonalChat(this.$Util.getAdminMemberIdx(), MEMBER_TYPE.USER, JOIN_CHAT_TYPE.CHAT_FOR_COACH_CERT);
        },
        closeRequestJoinForm(isComplete) {
            if (isComplete) {
                this.$GlobalStore.setIsShowRequestPopupForce(false)
                this.$router.push({ path: '/view/soccer_join?time=' + new Date().getTime(), props: { data: { mode: 'page' } } });
            }
            this.isForce = false
            this.isShowMakeRequestJoinForm = false
        },
        setMakeRequestJoinForm(isForce = false) {
            this.isForce = isForce
            this.$Util.checkAppLinkPageShow();
            this.$GlobalStore.setIsShowRequestPopupForce(false)
            this.$GlobalStore.addModal('SelectPlayerType')
            // this.isShowMakeRequestJoinForm = true
        },
        closeDirectRequestPopupOneDay() {
            localStorage.setItem('CLOSE_REQUEST_POPUP_ONE_DAY', moment().format('YYYY-MM-DD'))
            this.closeDirectRequestPopup()
        },
        sendRequestPost() {
            const requestInfo = this.$GlobalStore.requestInfo()
            this.closeDirectRequestPopup()
            this.$GlobalStore.addModal('SendOneRequestPost', { requestInfo: requestInfo, isModalBackTransparent: true, transitionName: 'bottom' })
        },
        closeDirectRequestPopup() {
            localStorage.setItem('CLOSE_REQUEST_POPUP_ONE_DAY', moment().format('YYYY-MM-DD'))
            this.$GlobalStore.setIsShowDirectRequestPopup(false)
        },
        async confirmCoach() {
            const parameters = {};
            parameters.is_coach_confirmed = 1;
            const res = await this.$Axios.post('/api/profile/save', parameters);
            if (res.data.code === ResponseCode.SUCCESS) {
                this.$GlobalStore.setLoginInfo(res.data.loginInfo);
                this.isShowBookmarkPopupConfirmed = false
            } else if (res.data.code === ResponseCode.FAIL) {
                this.$GlobalStore.showAlert(res.data.msg);
            }
        },
        async getDefaultData() {
            const $isSaveAppStart = sessionStorage.getItem('IS_APP_START') ? '0' : '1';
            const device = this.$cookies.get("device");

            const parameters = {};
            parameters.isSaveAppStart = $isSaveAppStart;
            const res = await axios.get('/login/data', { params: parameters });
            this.is_loaded = true;
            this.$GlobalStore.setLoginInfo(res.data.loginInfo);
            if (res.data.loginInfo) {
                this.$GlobalStore.setVisitReasonType(res.data.loginInfo.visit_reason)
            }

            sessionStorage.setItem('IS_APP_START', '1');

            // let isShowForceSoccerHow = false;
            // let isOpenChatWritten;

            //스키마 체크
            // SchemeManager;
            if (device === 'ios' || device === 'android') {
                const schemeManager = new SchemeManager(device);
                window.schemeManager = schemeManager;

                schemeManager.goScreen = (action, param0, param1, param2) => {
                    param1; param2;
                    if (action == PUSH_ACTION.WEB_NOWPAGE) {
                        this.$GlobalStore.addModal('ClassScheduleDetail', { mode: CLASS_TYPE.NOW, scheduleIdx: param0, noPopup: true, completeAction: () => { } })
                    } else if (action) {
                        //type title, param1 => refer_idx, param2 => action, param3 => param1, param4
                        this.goAction('', param0, action, param1, param2);
                    }
                }

                const schemes = await schemeManager.getSchemes();
                if (schemes) {
                    schemeManager.goScreen(schemes.action, schemes.param0, schemes.param1, schemes.param2);
                }
            } else {
                //웹 토큰 받기
                if (!this.$GlobalStore.isLogin()) {
                    const parameters = {};
                    await this.$Axios.post('/api/nologin/token', parameters);

                    if (location.pathname === '/help') {
                        this.$GlobalStore.addModal('SoccerhowCustomerSupport', { transitionName: '', isBackBtnHidden: true })
                    }
                }



                if (location.pathname === '/training') {
                    if (this.$route.query.type === 'request') {
                        const is_secret = this.$route.query.is_secret == 'true';
                        if (is_secret) {
                            this.$GlobalStore.addModal('RequestReportDetailSecret', { soccerhowIdx: this.$route.query.idx, is_from_pageframe: true })
                        } else {
                            this.$GlobalStore.addModal('RequestReportDetailNew', { soccerhowIdx: this.$route.query.idx, is_from_pageframe: true })
                        }
                    } else if (this.$route.query.type === 'learn') {
                        if (this.$route.query.is_secret) {
                            this.$GlobalStore.addModal('RequestReportDetailSecret', { soccerhowIdx: this.$route.query.idx })
                        } else {
                            this.$GlobalStore.addModal('RequestReportDetailNew', { soccerhowIdx: this.$route.query.idx })
                        }
                    }
                } else if (location.pathname === '/team_detail') {
                    this.$GlobalStore.addModal('SoccerTeamDetail', { isModalBackTransparent: true, teamIdx: this.$route.query.idx })
                } else if (location.pathname === '/position_pro') {
                    this.$GlobalStore.addModal('FindPositionProMain');
                } else if (location.pathname === '/sportlight') {
                    this.$GlobalStore.addModal('SpotLightList')
                }
            }

            if (this.$GlobalStore.isLogin()) {
                // isOpenChatWritten = await this.$Axios.get('/api/chat/check/opentalk/contents/exist')

                // this.$nextTick(() => {
                //     //특정 코치에게만 나오게
                //     const agree_targets = ['440732', '440733', '440803', '440809', '440853', '442080', '442083', '442084', '442093', '442343', '442378'];
                //     if (agree_targets.indexOf(this.$GlobalStore.loginInfo().idx) > -1) {
                //         if (!this.$hasOwnProperty(localStorage, 'HIDE_COACH_AGREEMENT')) this.isShowCoachAgreement = true;
                //     }
                // })
            } else {
                if (res.data.is_admin) {
                    this.$GlobalStore.setLoginInfo({ idx: '-1', isAdmin: true })
                } else {
                    if (!(device === 'ios' || device === 'android')
                        && (location.pathname === '/team'
                            || location.pathname === '/help'
                            || location.pathname === '/training'
                            || location.pathname === '/position_pro'
                            || location.pathname === '/training_main'
                            || location.pathname === '/sportlight'
                            || location.pathname === '/soccer_join'
                        )
                    ) {
                        // } else if ((device === 'ios' || device === 'android') && !this.$hasOwnProperty(localStorage, 'IS_HAS_LOGINED')) {
                        //     //앱 최초 실행 및 로그인 한적이 없을때 뜨도록.
                        //     this.$GlobalStore.addModal('MemberTypeSelect', {
                        //         isExistLoginBtn: true, isShowCloseBtn: false, completeAction: (register_type) => {
                        //             this.$GlobalStore.addModal('RegistTypeSelect', { isModalBackTransparent: true, transitionName: 'bottom', register_type: register_type });
                        //             // this.$GlobalStore.addModal('MemberRegist', { isModalBackTransparent: true, transitionName: 'bottom', register_type: register_type });
                        //         }
                        //     })
                    } else {
                        this.$GlobalStore.addModal('LoginIntro', { transitionName: '' });
                    }
                }
            }

            if (device === 'ios' || device === 'android') {
                this.$nextTick(() => {
                    if (device === 'android') {
                        window.Android.completeWebLoading();
                    } else if (device === 'ios') {
                        setTimeout(() => {
                            /*eslint-disable no-undef */
                            webkit.messageHandlers.ios.postMessage({ cmd: 'completeWebLoading' });
                        }, 300)
                    }
                });
            }

            if (this.$GlobalStore.isLogin() && this.$GlobalStore.loginInfo().is_coach_confirmed == 0 && this.$GlobalStore.loginInfo().is_temp_coach == '1') {
                let interval = null;
                interval = setInterval(async () => {
                    const res = await this.$Axios.get('/api/login/info');
                    if (res.data.loginInfo.is_coach == '1') {
                        this.isShowBookmarkPopupConfirmed = true;
                        clearInterval(interval);
                    }
                }, 10000);
            }

            //부모 결제 창
            if (location.pathname === '/parent_pay') {
                const target = this.$route.query.target;
                const pay_type = this.$route.query.pay_type;

                if(pay_type && pay_type == PARENT_PAY_TYPE.SOCCERHOW_SECRET_REQUEST){
                    this.$GlobalStore.addModal('SecretPayRequestform', { target: target })
                } else {
                    this.$GlobalStore.addModal('YouthPayRequestForm', { target: target })
                }


                // return
            }

            if (device === 'ios' || device === 'android') {
                setTimeout(() => {
                    try {
                        Pedometer.getLast(7).then(async (res) => {
                            const parameters = {};
                            parameters.data = JSON.stringify(res.data);
                            await this.$Axios.post('/api/member/step/save', parameters);

                        });
                    } catch (error) {
                        console.error('Error fetching pedometer data', error);
                    }
                }, 5000);

            }

            if (location.pathname === '/view/admin/statis/map') return;

            setTimeout(async () => {
                if (this.$GlobalStore.isLogin()) {
                    //TODO is_opentalk_written 가 현재는 사용되지 않는듯(MyPosition.vue에서 있지만 이 파일을 사용하지 않음)하여 강제 true 처리. 필요시 다시 활성화
                    await this.$Util.checkAfterLogin(res.data.isSoccerhowWritten, res.data.loginInfo, true/*isOpenChatWritten.data.is_opentalk_written*/)
                }

            }, 1000);
            if (process.env.NODE_ENV === 'production') {
                setTimeout(() => {
                    if (!this.$Util.checkIsLatestVersion()) {
                        this.$GlobalStore.showUpdatePopup();
                        // this.$GlobalStore.showAlert('최신 버전이 아닙니다.\n최신버전이 아닐경우 기능이 동작하지 않을 수 있습니다.\n최신버전으로 업데이트 후 이용해주세요.');
                    }
                }, 3000);
            }

            //푸시 아이디 갱신
            if (this.$route.query.push_id_refresh && this.$route.query.push_id_refresh == 1) {
                setTimeout(() => {
                    this.refreshPushId();
                }, 3000)
            }

            // //웹 포지션으로 넘어왔을시 가입 후에 포지션 찾기로 가도록 처리
            // if(this.$route.query && this.$route.query.from && this.$route.query.from === 'position_web'){
            //     window.is_from_position_web = true;
            //     // sessionStorage.setItem('IS_FROM_POSITION_WEB', '1');
            // }

            if (!document.querySelector('script[src="https://www.youtube.com/iframe_api"]')) {
                const tag = document.createElement("script");
                tag.src = "https://www.youtube.com/iframe_api";
                document.body.appendChild(tag);
            }

            window.onYouTubeIframeAPIReady = function () {
                console.log("YouTube API Loaded");
            };

            if (this.$GlobalStore.isLogin()) {
                this.$Util.checkDirectMessage()
                this.$Util.checkIsWriteRequestForm()
                this.$Util.checkIsCoach()

                // const savedPopupTime = localStorage.getItem('lastConfirmCloseTime');
                // const isOneDayPassed = !savedPopupTime || moment().diff(moment(savedPopupTime), 'hours') >= 24;

                // if ((!this.$GlobalStore.loginInfo().is_elite_pop_check || this.$GlobalStore.loginInfo().is_elite_pop_check == 0) && this.$GlobalStore.loginInfo().is_temp_coach == 0 && isOneDayPassed) {
                //     this.$GlobalStore.setIsShowMemberInfoPopup(true)
                // }
                const result = await this.$Axios.get('/api/my/notice/count');
                this.$GlobalStore.setNoticeCount(result.data.noticeCount)
            }
        },
        //type title, param1 => refer_idx, param2 => action, param3 => param1, param4
        async goAction(type, param1, param2, param3, param4, isFromNotice = false) {
            console.log(param2, param3, param4);
            if (!isFromNotice) {
                this.$Util.sendEventClick('푸시메시지_앱진입', true)
            }
            if (param2 && param2 != '0') {
                switch (param2) {
                    case '1': //용병
                        this.$router.push({ path: '/view/mercenary?time=' + new Date().getTime(), props: { data: { mode: 'page' } } });
                        break;
                    case '2': //사커하우
                        this.$router.push({ path: '/view/soccerhow?time=' + new Date().getTime(), props: { data: { mode: 'page' } } });
                        break;
                    case '3': //사커조인
                        this.$router.push({ path: '/view/join?time=' + new Date().getTime(), props: { data: { mode: 'page' } } });
                        break;
                    case '4': //마이페이지
                        this.$router.push({ path: '/view/my?time=' + new Date().getTime(), props: { data: { mode: 'page' } } });
                        break;
                    case '5': //포지션찾기
                        if (!this.$GlobalStore.isLogin()) {
                            this.$GlobalStore.showLoginConfirm();
                            return;
                        }
                        this.$GlobalStore.addModal('MyPosition');
                        break;
                    case '6': //1:1문의
                        this.$Util.showBrowser(ASK_URL);
                        break;
                    case '7': //웹링크
                        this.$Util.showBrowser(param3);
                        break;
                    case '8': //공지사항 특정글
                        this.$GlobalStore.addModal('NotificationDetail', { idx: param1, transitionName: 'bottom', title: '공지사항' });
                        break;
                    // case '9': //지점상세
                    //     this.$GlobalStore.addModal('BranchDetail', { idx: param1 });
                    //     break;
                    // case '10': //코치상세
                    //     this.$GlobalStore.addModal('CoachDetail', { coachIdx: param1 });
                    //     break;
                    case '11': //홈 이벤트 랜딩페이지
                        this.$GlobalStore.addModal('LandingPage', { subPath: param1 })
                        break;
                    case '12': //포지션찾기 프로
                        this.$GlobalStore.addModal('FindPositionProStart');
                        break;
                    case '13': //조인 만들기
                        if (!this.$GlobalStore.isLogin()) {
                            this.$GlobalStore.showLoginConfirm();
                            return;
                        }
                        if (!this.$Util.checkProfileCompleteOrShowRequiredProfile()) return;
                        this.$GlobalStore.addModal("MakeJoinOrSchedule", { type: SOCCER_JOIN_SCHEDULE.JOIN, joinOrSchedule: '조인을 만들어볼게요' });
                        break;
                    // case '14': //용병 설정
                    //     this.$GlobalStore.addModal('MercenarySettings')
                    //     break;
                    case PUSH_ACTION.MERCENARY: //용병
                        this.$GlobalStore.closeModalAll();
                        this.$router.push({ path: '/view/mercenary?time=' + new Date().getTime(), props: { data: { mode: 'page' } } });
                        break;
                    case PUSH_ACTION.MAKE_MERCENARY_SCHEDULE: //용병 스케줄 만들기
                        if (!this.$Util.checkProfileCompleteOrShowRequiredProfile()) return;
                        this.$GlobalStore.addModal('MakeJoinOrSchedule', { type: SOCCER_JOIN_SCHEDULE.MERCENARY_SCHEDULE, joinOrSchedule: '용병 스케줄을 만들어볼게요', joinIdx: 0 });
                        break;
                    case PUSH_ACTION.SOCCERHOW_TAB_SOCCERHOW: //용병 스케줄 만들기
                        this.$router.push({ path: '/view/soccerhow?time=' + new Date().getTime() + '&init_tab=' + SOCCER_HOW_TYPE.SOCCERHOW });
                        this.$GlobalStore.closeModalAll();
                        break;
                    case PUSH_ACTION.SELECT_POSITION_FIND:
                        if (!this.$Util.checkProfileCompleteOrShowRequiredProfile()) return;
                        // this.$GlobalStore.addModal('FindPositionProMain', {});
                        this.$GlobalStore.addModal('SelectFindPosition')
                        break;
                    case PUSH_ACTION.NOTICE_EVENT_DETAIL: //이벤트 특정글
                        this.$GlobalStore.addModal('NotificationDetail', { idx: param1, transitionName: 'bottom', title: '이벤트' });
                        break;
                    case PUSH_ACTION.HOME_LEARN: //축구 배우기
                        this.$GlobalStore.closeModalAll();
                        this.$router.push({ path: '/view/soccer_learn?time=' + new Date().getTime(), props: { data: { mode: 'page' } } });
                        break;
                    case PUSH_ACTION.HOME_JOIN: //축구팀 입단
                        this.$GlobalStore.closeModalAll();
                        this.$router.push({ path: '/view/soccer_join?time=' + new Date().getTime(), props: { data: { mode: 'page' } } });
                        break;
                    case PUSH_ACTION.TRAINING_MAIN: //트레이닝 메인
                        this.$GlobalStore.closeModalAll();
                        this.$router.push({ path: '/training_main?time=' + new Date().getTime(), props: { data: { mode: 'page' } } });
                        break;
                    case PUSH_ACTION.MYCHAT: //멤버모집/회원관리
                        this.$GlobalStore.closeModalAll();
                        this.$router.push({ path: '/view/mychat?time=' + new Date().getTime(), props: { data: { mode: 'page' } } });
                        break;
                    case PUSH_ACTION.MESSAGE: //메시지
                        this.$GlobalStore.closeModalAll();
                        this.$router.push({ path: '/view/mychat?time=' + new Date().getTime() + '&is_message=true', props: { data: { mode: 'page' } } });
                        break;
                    case PUSH_ACTION.SPORTLIGHT_LIST: //스포트라이트 목록
                        this.$GlobalStore.addModal('SpotLightList');
                        break;
                    case PUSH_ACTION.SPORTLIGHT_DETAIL: //스포트라이트 상세
                        this.$GlobalStore.addModal('InterviewDetail', { spotlightIdx: param1 });
                        break;
                    case PUSH_ACTION.TEAM_DETAIL: //팀 상세
                        this.$GlobalStore.addModal('SoccerTeamDetail', { isModalBackTransparent: true, teamIdx: param1 });
                        break;
                    case PUSH_ACTION.HOME: //홈 화면
                        this.$GlobalStore.closeModalAll();
                        this.$router.push({ path: '/view/home?time=' + new Date().getTime(), props: { data: { mode: 'page' } } });
                        break;
                    case PUSH_ACTION.SOCCERHOW_DETAIL:
                        // 누구나 답변 상세페이지로 이동되는 알림
                        this.$GlobalStore.showAlert('더이상 지원되지않는 화면입니다.');
                        // this.showSoccerHowDetail(param1);
                        break;
                    case PUSH_ACTION.JOIN_DETAIL: {
                        const res = await this.$Axios.get('/api/join/list', { params: { join_idx: param1 } });
                        if (!res.data.joins) {
                            this.$GlobalStore.showAlert('삭제된 멤버톡입니다.');
                            return;
                        }
                        await this.$Axios.showChattingBySoccerJoinIdx(res.data.joins.chat_idx);
                    }
                        break;
                    case PUSH_ACTION.JOIN_SCHEDULE_DETAIL:
                        this.$GlobalStore.addModal('MemberTalkScheduleDetailModalWrap', { scheduleIdx: param1, transitionName: '', isModalBackTransparent: true });
                        break;
                    case PUSH_ACTION.JOIN_TALK:
                        {
                            await this.$Axios.showChattingBySoccerJoinIdx(param1);
                        }
                        break;
                    case PUSH_ACTION.SOCCERHOW_REQUEST_DETAIL:
                        {
                            this.$GlobalStore.addModal('TrainingRequestDetail', { main_type: MAIN_TYPE.SOCCER_TEAM_JOINING, isModalBackTransparent: true, isExpert: this.isExpert, soccerhowIdx: param1 })
                        }
                        break;
                    case PUSH_ACTION.SOCCERHOW_TRAINING_DETAIL:
                        {
                            this.$GlobalStore.addModal('TrainingRequestDetail', { main_type: MAIN_TYPE.SOCCER_LEARN, isModalBackTransparent: true, isExpert: this.isExpert, soccerhowIdx: param1 })
                        }
                        break;
                    case PUSH_ACTION.DIRECT_MESSAGE_LIST:
                        {
                            this.$router.push({ path: '/view/mychat?time=' + new Date().getTime() + '&is_direct_message=true', props: { data: { mode: 'page' } } });
                        }
                        break;
                    case PUSH_ACTION.CURRENT_SCOUT_USER_SECRET:
                        {
                            this.$GlobalStore.addModal('CurrentScoutUserSecret');
                        }
                        break;
                    case PUSH_ACTION.REQUEST_REPORT_DETAIL_SECRET:
                        {
                            this.$GlobalStore.addModal('RequestReportDetailSecret', { soccerhowIdx: param1 });
                        }
                        break;
                    case PUSH_ACTION.ACTIVITY_RANKING:
                        {
                            this.$GlobalStore.addModal('ActivityRanking');
                        }
                        break;
                    case PUSH_ACTION.POLL_DETAIL:
                        {
                            this.$GlobalStore.addModal('PollPostDetail', { poll_idx: param1 })
                        }
                        break;
                    // case PUSH_ACTION.MEMBER_EVALUATION:
                    //     {
                    //         const res = await this.$Axios.get('/api/join/schedule/list', { params: { join_schedule_idx: param1 } });
                    //         this.$GlobalStore.addModal('EvaluateMemberStart', { scheduleIdx: param1, scheduleList: res.data.join_schedules })
                    //
                    //     }
                    //     break;
                    // case PUSH_ACTION.MEMBER_EVALUATION_RESULT:
                    //     this.$GlobalStore.addModal('EvaluateMemberResult', { scheduleIdx: param1 });
                    //     break;
                    case PUSH_ACTION.PROFILE: {
                        console.log('param1 : ', param1, 'param2', param3);
                        Util.showProfile(param1, param3);
                        break;
                    }
                    case PUSH_ACTION.OPEN_SCHEDULE_DETAIL:
                        this.$GlobalStore.addModal('MercenaryScheduleDetailPopup', { transitionName: '', isModalBackTransparent: true, schedule_idx: param1 });
                        break;
                    case PUSH_ACTION.LESSON_SCHEDULE_DETAIL:
                        this.$GlobalStore.addModal('TeamTrainingDetail', { scheduleIdx: param1 });
                        break;
                    // case PUSH_ACTION.JOIN_INVITATION_LIST:
                    //     this.$GlobalStore.addModal('HomeFeedMemberTalkDetailPopup', { transitionName: '', isModalBackTransparent: true, membertalk_idx: param1 })
                    //     break;
                    // case PUSH_ACTION.OPEN_TALK: {
                    //     const parameters = {};
                    //     parameters.code = param3;
                    //     const res = await this.$Axios.get('/api/region/bycode', { params: parameters });
                    //     if (res.data.region) {
                    //         this.$GlobalStore.addModal('MercenaryMainModalPopup', { transitionName: '', isModalBackTransparent: true, selectDong: res.data.region });
                    //     }
                    // }
                    //     break;
                    case PUSH_ACTION.POSITION_DELAY:
                        console.log(param3);
                        this.$GlobalStore.addModal('PositionResultDelay', { position_type: param3 });
                        break;
                    case PUSH_ACTION.CHATTING:
                        this.$Axios.showChattingBySoccerJoinIdx(param1);
                        break;
                    case PUSH_ACTION.LEARN_TOP_BANNER_DETAIL:
                        this.$GlobalStore.addModal('LearnBannerDetail', { bannerIdx: param1 })
                        break;
                    case PUSH_ACTION.PAYMENT_SECRET_REQUEST_FORM:
                        this.$GlobalStore.addModal('PaymentSecretRequestForm', { status_bar_text_color: 'white' });
                        break;
                }
                return;
            }

            // if (type === '사커하우') {
            //     this.showSoccerHowDetail(param1);
            // } else if (type === '사커조인신청' || type === '채팅알림') {
            //     if (device === 'ios' || device === 'android') {
            //         this.$Axios.showChattingBySoccerJoinIdx(param1);
            //     } else {
            //         this.$Util.showChatWithAdmin();
            //     }
            // } else if (type === '레슨권 알림') {
            //     this.$GlobalStore.addModal('MyMemberships', { saleCount: 0 });
            // } else if (type === '레슨 일정' || type === '레슨 알림') {
            //     this.$GlobalStore.addModal('LessonSchedules', { reservationCount: 0 });
            // } else if (type === '테스트') {
            //     this.$GlobalStore.showAlert('test');
            // }
        },
        async setPushToken() {
            // alert(this.$cookies.get("device"));
            const device = this.$cookies.get("device");
            const pushManager = PushManager(device, this.goAction);
            window.pushCustomManager = pushManager;

            if (this.$route.query.type != null) {
                pushManager.goScreen(this.$route.query.type, this.$route.query.param1, this.$route.query.param2, this.$route.query.param3, this.$route.query.param4);
            }

            if (device === 'ios' || device === 'android') {
                setTimeout(this.addPushDevice, 5000);
            }
        },
        async showSoccerHowDetail(soccerHowIdx) {
            const res = await this.$Axios.get('/api/soccerhow/deep', { params: { soccerHowIdx: soccerHowIdx } });
            if (res.data.code === 0) {
                const soccerHowWithParent = res.data.soccerHowWithParent;


                let deep = 1;
                let parent_type = soccerHowWithParent.type;
                let regionCode = res.data.soccerHowWithParent.region_code;
                if (soccerHowWithParent.parent_idx2) {
                    soccerHowIdx = soccerHowWithParent.parent_idx2;
                    parent_type = soccerHowWithParent.parent_type2;
                    regionCode = soccerHowWithParent.parent_region_code2;
                } else if (soccerHowWithParent.parent_idx1) {
                    soccerHowIdx = soccerHowWithParent.parent_idx1;
                    parent_type = soccerHowWithParent.parent_type1;
                    regionCode = soccerHowWithParent.parent_region_code1;
                }

                deep;
                parent_type;
                regionCode;
            }
        },
        async addPushDevice() {
            const uuid = await window.pushCustomManager.getUuid();
            const token = await window.pushCustomManager.getPushToken();

            if ((token === '(null)' || token.length < 20) && this.addPushDeviceCnt < 6) {
                this.addPushDeviceCnt++;
                setTimeout(this.addPushDevice, 10000);
                return;
            }

            if (uuid !== "" && (!this.$hasOwnProperty(localStorage, 'uuid') || localStorage['uuid'] !== uuid || !this.$hasOwnProperty(localStorage, 'pushToken') || localStorage['pushToken'] !== token)) {
                var parameter = {};
                parameter.uuid = uuid;
                parameter.token = token;
                parameter.os = this.$cookies.get('device') === 'ios' ? 'iOS' : this.$cookies.get('device');
                var devName = await window.pushCustomManager.getDeviceName();
                if (devName) parameter.devName = devName;

                const res = await this.$Axios.post('/api/uuid', parameter);
                if (res.data.code === 0) {
                    localStorage.setItem('uuid', uuid);
                    localStorage.setItem('pushToken', token);
                } else if (res.data.code === -1) {
                    this.showAlert(res.data.msg);
                }
            }
        },
        // async saveGpsLocation(location) {
        //     const parameters = {};
        //     parameters.latitude = location.latitude;
        //     parameters.longitude = location.longitude;
        //     await this.$Axios.post('/api/my/location/save', parameters);
        // },
        async refreshPushId() {
            const uuid = await window.pushCustomManager.getUuid();
            const token = await window.pushCustomManager.getPushToken();
            const parameters = {};
            parameters.uuid = uuid;
            parameters.token = token;
            await this.$Axios.post('/api/push/refresh/id', parameters);
        },
        // renewAds() {
        //     const app_version = this.$cookies.get('appv');
        //     const device = this.$cookies.get('device');
        //
        //     let is_latest_version = false;
        //     if (device === 'android') {
        //         is_latest_version = parseInt(app_version) >= 37;
        //     } else if (device === 'ios') {
        //         is_latest_version = parseInt(app_version) >= 40;
        //     }
        //
        //     if (is_latest_version && (device === 'ios' || device === 'android')) {
        //         setInterval(() => {
        //             if (device === 'ios') {
        //                 webkit.messageHandlers.ios.postMessage({ cmd: 'setAds' });
        //             } else if (device === 'android') {
        //                 window.Android.setAds();
        //             }
        //         }, 1000 * 3000);
        //     }
        // }
    },
    mounted: function () {
        const device = this.$cookies.get("device")
        this.device_type = device
        this.$GlobalStore.setDevice(device)
        // this.addLeftMenuModal({view: 'leftmenumain'});
        this.$store.commit('setModalInstance', this);

        setTimeout(() => {
            this.is_statubar_height_loaded = true;
        }, 500)

        this.setPushToken();
        // this.renewAds();

        // const device = this.$cookies.get('device');
        // if ((device === 'android' || device === 'ios')) {
        //     let gpsCheckInterval;
        //     gpsCheckInterval = setInterval(async () => {
        //         if (!this.$GlobalStore.loginInfo().idx) return;
        //         const location = await GpsManager.getLocation();
        //         if (!location.latitude || !location.longitude) return;
        //         clearInterval(gpsCheckInterval);
        //         this.saveGpsLocation(location);
        //     }, 30000);
        // }

    },
    created: function () {
        this.confirmCoach = this.$Once(this.confirmCoach);
        // this.setLoginInfo();
        if (this.$route.path.indexOf('/share') !== 0) {
            this.getDefaultData();
        } else if (this.$route.path.indexOf('/share/') > -1) {
            this.is_loaded = true;
        }
    }
}
</script>

<style scoped>
.fade_toast-enter-active,
.fade_toast-leave-active {
    transition: opacity 0.3s;
}

.fade_toast-enter,
.fade_toast-leave-to {
    opacity: 0;
}

.bounce_back_cover {
    position: fixed;
    left: 0px;
    top: 0px;
    bottom: 0px;
    width: 100vw;
    background-color: white;
    display: none;
}

.mainwrap {
    position: fixed;
    left: 0px;
    top: 0px;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.mainwrap_pc {
    position: fixed;
    left: 50%;
    transform: translateX(-50%);
    top: 0px;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    max-width: 600px;
    overflow: hidden;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15);
}

.router_contents {
    height: 100%;
    display: flex;
    flex-direction: column;
    flex: 1;
    left: 0%;
    background-color: white;
    overflow: hidden;
}

.leftmenu {
    position: fixed;
    height: 100%;
    left: 0%;
    top: 0px;
    width: 100%;
    /*z-index:10;*/
}

.leftmenu_list {
    position: absolute;
    left: 0px;
    top: 0px;
    height: 100%;
    width: 300px;
    background-color: #2F4050;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.leftmenu_back {
    position: fixed;
    height: 100%;
    left: 0%;
    top: 0px;
    width: 100%;
    background-color: black;
    opacity: 0.5
}

.each_modal {
    position: fixed;
    left: 0;
    top: 0;
    bottom: 0;
    width: 100vw;
    background-color: white;
}

.each_modal_pc {
    position: fixed;
    left: 50%;
    transform: translateX(-50%);
    top: 0;
    bottom: 0;
    width: 100vw;
    max-width: 600px;
    background-color: white;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15);
    overflow: hidden;
}

.modal {
    height: 100%;
    display: flex;
    flex-direction: column;
    /*background-color:rgb(241, 241, 241);*/
}

.right-enter-active,
.right-leave-active {
    transition: left .3s;
}

.right-enter,
.right-leave-to {
    left: 100%;
}

.rightPc-enter-active,
.rightPc-leave-active {
    transition: left 0.3s;
}

.rightPc-enter,
.rightPc-leave-to {
    left: 150%;
}

.bottom-enter-active,
.bottom-leave-active {
    transition: top .5s;
}

.bottom-enter,
.bottom-leave-to {
    top: 100%;
}

.fade2-enter-active,
.fade2-leave-active {
    transition: opacity 0.5s;
}

.fade2-enter,
.fade2-leave-to {
    opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
    transition: left .3s;
}

.fade-enter,
.fade-leave-to {
    left: -100%;
}

.leftmenuright-enter-active,
.leftmenuright-leave-active {
    transition: transform 0.3s;
}

.leftmenuright-enter,
.leftmenuright-leave-to {
    transform: translateX(100%);
}

.leftmenu_bottom {
    height: 55px;
}

.leftmenu_each_modal {
    position: absolute;
    left: 0px;
    top: 0px;
    width: 300px;
    height: 100%;
}

.fadeTop2-enter-active,
.fadeTop2-leave-active {
    transition: all .5s;
}

.fadeTop2-enter,
.fadeTop2-leave-to {
    top: 100%;
    opacity: 0;
}
</style>
